import React from 'react';
import { theme } from '../../styles/theme';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning' | 'info';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ 
  children, 
  variant = 'default', 
  size = 'md',
  className = '' 
}) => {
  const baseClasses = theme.components.badge.base;
  
  const variantClasses = {
    default: theme.components.badge.variants.default,
    secondary: theme.components.badge.variants.secondary,
    destructive: theme.components.badge.variants.error,
    outline: 'border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300',
    success: theme.components.badge.variants.success,
    warning: theme.components.badge.variants.warning,
    info: theme.components.badge.variants.default,
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-sm',
    lg: 'px-3 py-1 text-sm'
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <span className={classes}>
      {children}
    </span>
  );
}; 